<div class="modal-stepper">
  <h2 mat-dialog-title class="modal-stepper-header">
    <atom-label [text]="title" class="modal-stepper-header__title"></atom-label>
    <atom-button
      [isPrimaryButton]="false"
      [displayIcon]="true"
      [iconType]="'discard'"
      (click)="onCloseModal()"
    >
    </atom-button>
  </h2>

  <mat-dialog-content class="modal-stepper-body">
    <mat-stepper [linear]="isLinear" #stepper>

      <ng-template matStepperIcon="edit">
        <mat-icon>check</mat-icon>
      </ng-template>

      <mat-step
        *ngFor="let step of steps"
        [label]="step.label | translate"
        [completed]="step.stepControl?.valid ?? true"
      >
        <ng-container [ngTemplateOutlet]="step.template"> </ng-container>
      </mat-step>
    </mat-stepper>
  </mat-dialog-content>

  <mat-dialog-actions class="modal-stepper-footer" [ngClass]="{'first-step': stepper.selectedIndex === 0}">
    <atom-button
      [isPrimaryButton]="false"
      [label]="'Atrás'"
      (click)="handlePrevious()"
      *ngIf="stepper.selectedIndex !== 0"
    >
    </atom-button>

    <atom-button
      [isPrimaryButton]="true"
      [label]="nextButtonText"
      [displayIcon]="isLastStep && !!lastStepButtonIcon"
      [iconType]="lastStepButtonIcon"
      (click)="handleNext()"
    >
    </atom-button>
  </mat-dialog-actions>
</div>
